import React from "react";
import TableHelp from "../../components/Tables/help";

const Help = () => {
  return (
    <TableHelp isPage={true} />
  );
};
export default Help;
